import {product} from "./src/Product";

(function (Drupal) { // closure
	'use strict';
	
	// Popin
	Drupal.behaviors.product = product;
}(Drupal));